import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnDestroy {
  sideNavOpen: boolean = false;
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges();
      console.log('test');
    };
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.sideNavOpen = !this.mobileQuery.matches;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  backDropClicked() {
    console.log(this.sideNavOpen);
    this.sideNavOpen = false;
  }

  onSidenavOpened() {
    if (this.mobileQuery.matches) {
      document.body.style.overflow = 'hidden';
    }
  }

  onSidenavClosed() {
    document.body.style.overflow = '';
  }
}
